// extracted by mini-css-extract-plugin
module.exports = {"root":"ScanIcon_root__2PxRB","text":"ScanIcon_text__1QY7c","icon":"ScanIcon_icon__3XSe_","hidden":"ScanIcon_hidden__3hjqY"};